
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/offers/[id]",
      function () {
        return require("private-next-pages/offers/[id].jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/offers/[id]"])
      });
    }
  